module.exports = __webpack_public_path__ + "static/media/paymentcheck.f5bc9a94.svg";